/*
 * @Author: zyy
 * @Date: 2022-11-21 14:49:14
 * @LastEditors: zyy
 * @LastEditTime: 2022-11-21 16:42:55
 * @Description: default
 */
import shopRequests from "../shopRequest";
import Qs from 'qs'
export default {
    // 订单列表
    list(params) {
        return shopRequests.get('/shop/addons/shopro/admin_api_comment/index', {
            params,
        })
    },
    add(params) {
        return shopRequests.post('/shop/addons/shopro/admin_api_comment/add', params)
    },
    edit(params) {
        return shopRequests.post('/shop/addons/shopro/admin_api_comment/edit', params)
    },
    del(ids) {
        return shopRequests.post('/shop/addons/shopro/admin_api_comment/del', {
            ids: [ids]
        })
    }

}